import 'core-js';
import 'regenerator-runtime/runtime';

import './sentry'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import VTooltip from 'v-tooltip'
import VueTour from 'vue-tour'

var _ = require('lodash')

Vue.use(VTooltip)
Vue.use(VueTour)
window.Vue = Vue

window.moment = moment

Vue.prototype.moment = moment
moment.locale(Lang.locale)

Vue.prototype.trans = (key, replacement) => {
  return Lang.get(key, replacement)
}

Vue.prototype.trans_lc = (key, replacement) => {
  const translation = Lang.get(key, replacement)
  return translation.charAt(0).toLowerCase() + translation.slice(1)
}

Vue.prototype.trans_choice = (key, amount, replacement) => {
  return Lang.choice(key, amount, replacement)
}

Vue.prototype.trans_choice_lc = (key, amount, replacement) => {
  const translation = Lang.choice(key, amount, replacement)
  return translation.charAt(0).toLowerCase() + translation.slice(1)
}

Vue.set(Vue.prototype, '_', _)

window.axios = axios
window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'responseType': 'json',
}
window.Pusher = require('pusher-js')

require('../services/errorHandler')
